import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { setInfoBeneficiar } from 'redux/beneficiarDetail/slice';
import { BeneficiarTypes } from 'redux/Api/beneficiariesApi/type';
import { InputText } from 'ui/InputText';
import { Button } from 'ui/Button';
import { BeneficiariesTabBtn } from 'ui/BeneficiariesTabBtn';
import ModalUpdateCastomer from './ModalUpdateCastomer';
import styles from './BeneficiariesDetails.module.scss';
import { Title } from 'components/Title';

interface CastomerDataFormProps {
  data: BeneficiarTypes | undefined;
  id: string | undefined;
  modalCustomerOpen: boolean;
  setModalCustomerOpen: (open: boolean) => void;
  refetch: () => void;
}

export default function CastomerDataForm({
  data,
  id,
  modalCustomerOpen,
  setModalCustomerOpen,
  refetch,
}: CastomerDataFormProps) {
  const { infoBeneficiar } = useSelector((state: RootState) => state.beneficiarSlice);
  const dispatch = useDispatch();

  const openModalUpdateCustomerHandler = () => {
    setModalCustomerOpen(true);
  };

  return (
    <div className={styles.left}>
      <div className={styles.left_title}>
        <Title title={`Заказчик №${data?.id}`} />
        <div style={{ display: 'flex', gap: '10px' }}>
          <BeneficiariesTabBtn
            isActive={data?.beneficiary?.is_active}
            title={data?.beneficiary?.is_active ? 'Активен' : 'Не активен'}
          />
          <Button
            className={styles.button}
            onClick={openModalUpdateCustomerHandler}
            theme='filed'>
            Изменить
          </Button>
        </div>
        <ModalUpdateCastomer
          id={id || ''}
          isOpen={modalCustomerOpen}
          onClose={() => setModalCustomerOpen(false)}
          refetch={refetch}
        />
      </div>
      <InputText
        value={infoBeneficiar?.jur_name || ''}
        type='text'
        placeholder='Название юр. лица'
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          dispatch(
            setInfoBeneficiar({
              key: 'jur_name',
              value: e.target.value,
              step: false,
            }),
          )
        }
        isDisabled
      />
      <InputText
        value={infoBeneficiar?.jur_address || ''}
        type='text'
        placeholder='Юридический адрес компании'
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          dispatch(
            setInfoBeneficiar({
              key: 'jur_address',
              value: e.target.value,
              step: false,
            }),
          )
        }
        isDisabled
      />
      <InputText
        value={infoBeneficiar?.director?.fio}
        type='text'
        placeholder='ФИО'
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          dispatch(
            setInfoBeneficiar({
              key: 'director',
              value: e.target.value,
              step: true,
              secondKey: 'fio',
            }),
          )
        }
        isDisabled
      />
      <div className={styles.inputBlock}>
        <InputText
          value={infoBeneficiar?.phone || ''}
          type='text'
          placeholder='Телефон'
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            dispatch(
              setInfoBeneficiar({
                key: 'phone',
                value: e.target.value,
                step: false,
              }),
            )
          }
          isDisabled
        />
        <InputText
          value={infoBeneficiar?.email || ''}
          type='text'
          placeholder='Почта'
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            dispatch(
              setInfoBeneficiar({
                key: 'email',
                value: e.target.value,
                step: false,
              }),
            )
          }
          isDisabled
        />
      </div>
      <div className={styles.inputBlock}>
        <InputText
          value={infoBeneficiar?.inn || ''}
          type='text'
          placeholder='ИНН'
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            dispatch(
              setInfoBeneficiar({
                key: 'inn',
                value: e.target.value,
                step: false,
              }),
            )
          }
          isDisabled
        />
        <InputText
          value={infoBeneficiar?.kpp || ''}
          type='text'
          placeholder='КПП'
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            dispatch(
              setInfoBeneficiar({
                key: 'kpp',
                value: e.target.value,
                step: false,
              }),
            )
          }
          isDisabled
        />
      </div>
      <div className={styles.inputBlock}>
        <InputText
          value={infoBeneficiar?.ogrn || ''}
          type='text'
          placeholder='ОГРН'
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            dispatch(
              setInfoBeneficiar({
                key: 'ogrn',
                value: e.target.value,
                step: false,
              }),
            )
          }
          isDisabled
        />
      </div>
    </div>
  );
}
